module.exports = __webpack_public_path__ + "static/media/icon-14.07a75e67.png";